import { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { signout } from '../../../redux/actions/userActions'

class Logout extends Component {
  signoutUser () {
    this.props.signout()
    this.props.history.push('/')
  }

  componentDidMount () {
    this.signoutUser()
  }

  render () {
    return (null)
  }
}

export default connect(null, { signout })(withRouter(Logout))



// WEBPACK FOOTER //
// ./src/components/account/log_in/Logout.js